/**
 * The site's top-level addresses, named once (review MR !1 N21).
 *
 * The routing table, the session guard and every screen that navigates in code read these, so renaming an address is one edit
 * and a typo is a compile error rather than a silent redirect to `/plans` through the wildcard.
 */
export const APP_PATH = {
  PLANS: 'plans',
  VERIFY: 'verify',
  PURCHASE: 'purchase',
  MY_MEMBERSHIP: 'my-membership',
  PROFILE: 'profile',
  REFER: 'refer',
  MEMBERSHIP: 'membership',
  MEMBERSHIP_PAYMENT: 'membership-payment',
  DOCTORS: 'doctors',
  FIND_CARE: 'find-care',
  REVIEWS: 'reviews',
  LEGAL: 'legal',
  /** A partner's published page, one address per kind (`/doctor/<slug>`, …). */
  PAGE_DOCTOR: 'doctor',
  PAGE_HOSPITAL: 'hospital',
  PAGE_LABORATORY: 'laboratory',
  PAGE_RADIO: 'radio',
} as const;

export type AppPath = (typeof APP_PATH)[keyof typeof APP_PATH];

/** The absolute form a router command or link takes: `'/plans'`. */
export function appUrl(path: AppPath): string {
  return `/${path}`;
}

/**
 * The anchors on the /legal page, written once: the page gives each article its id from here and the footer links to the same names,
 * so renaming a document type cannot silently break a footer link (review MR !9 N2). Each equals its document type in lower case.
 */
export const LEGAL_FRAGMENT = {
  TERMS: 'terms',
  PRIVACY: 'privacy',
  CANCELLATION_REFUND: 'cancellation_refund',
} as const;
